import { customFetch } from '../composables/useCustomFetch';

export async function getAppVersion(options = {}) {
  return await customFetch('/api/version', 'get', options);
}

export async function getBackendVersion(options = {}) {
  return await customFetch('/api/version/package-be', 'get', options);
}
